import { COMMA, ENTER } from "@angular/cdk/keycodes";
import {
  Component,
  ElementRef,
  OnInit,
  Input,
  ViewChild,
  AfterViewInit,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { Observable, merge, forkJoin, BehaviorSubject } from "rxjs";
import { map, mergeAll, startWith, switchMap, take, tap } from "rxjs/operators";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { JoyrideService } from "ngx-joyride";

import { RepositoriesService } from "@service/repositories.service";
import { ProjectService } from "@service/project.service";
import { Events } from "@service/events.service";

import { Repository } from "@model/Repository";
import { Message } from "@model/Message";
import { JoyrideSteps } from "@model/JoyrideSteps";

@Component({
  selector: "app-modal-repository",
  templateUrl: "./modal-repository.component.html",
  styleUrls: ["./modal-repository.component.scss"],
})
export class ModalRepositoryComponent implements OnInit, AfterViewInit {
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [COMMA, ENTER];
  projectCtrl = new FormControl();
  obsArray: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  filteredProjects: Observable<any[]> = this.obsArray.asObservable();
  @ViewChild("projectInput", { static: false })
  projectInput: ElementRef<HTMLInputElement>;

  @Input()
  public repository: Repository = {} as Repository;
  @Input()
  public isAuthor: boolean = true;

  public form: FormGroup;
  public submitted: boolean = false;
  public projects: any[] = [];
  public selectedProjects: any[] = [];

  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private repositoriesService: RepositoriesService,
    private projectsService: ProjectService,
    private readonly toast: ToastrService,
    private readonly events: Events,
    private readonly joyrideService: JoyrideService
  ) {
    this.filteredProjects = this.projectCtrl.valueChanges.pipe(
      startWith(null),
      map((project: any | null) =>
        project ? this._filter(project) : this.projects.slice()
      )
      // tap(val => console.log(val))
    );
  }

  private _filter(value: any): any[] {
    let filterValue = "";
    if (typeof value === "string") {
      filterValue = value.toLowerCase();
    } else {
      filterValue = value.title.toLowerCase();
    }
    return this.projects.filter((project) =>
      project.title.toLowerCase().includes(filterValue)
    );
  }

  hasIncluded(project) {
    return this.selectedProjects.map((s) => s.id).includes(project.id);
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.selectedProjects.push(event.option.value);
    this.projectInput.nativeElement.value = "";
    this.projectCtrl.setValue(null);
  }

  remove(project: any): void {
    const index = this.selectedProjects
      .map((project) => project.id)
      .indexOf(project.id);

    if (index >= 0) {
      // this.filteredProjects.pipe(take(1)).subscribe(val => {
      //   // console.log(val, this.selectedProjects[index]);
      //   const newArr = [...val, this.selectedProjects[index]];
      //   console.log(newArr);
      //   this.obsArray.next(newArr);
      // });
      // this.projectCtrl.valueChanges.pipe(
      //   tap(val => {
      //     this.projectCtrl.setValue([...val, this.selectedProjects[index]]);
      //   })
      // );
      // this.projectCtrl.setValue(this.selectedProjects[index]);
      this.selectedProjects.splice(index, 1);
      // this.projectInput.nativeElement.value = '';
      // this.projectCtrl.setValue(null);
    }
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      name: [
        this.repository.name,
        [Validators.required, Validators.minLength(10)],
      ],
      description: [
        this.repository.description,
        [Validators.required, Validators.minLength(10)],
      ],
    });

    setTimeout(() => {
      this.projectsService
        .getProjectWhithoutRepository(this.isAuthor)
        .subscribe((projects) => {
          if (this.repository.id) {
            this.selectedProjects = [...this.repository.projects];
            this.projects = [...this.repository.projects, ...projects];
          } else {
            this.projects = [...projects];
          }
        });
    }, 0);
  }

  ngAfterViewInit() {
    const joyrideSteps: JoyrideSteps = JSON.parse(
      localStorage.getItem("joyrideSteps")
    );
    if (
      typeof joyrideSteps.secondStep === "undefined" ||
      joyrideSteps.secondStep === false
    ) {
      this.joyrideService
        .startTour({
          steps: ["firstStep"],
          customTexts: {
            next: "Próximo",
            prev: "Anterior",
            done: "Ok",
          },
        })
        .subscribe(() => {
          localStorage.setItem(
            "joyrideSteps",
            JSON.stringify({ ...joyrideSteps, secondStep: true })
          );
        });
    }
  }

  save() {
    this.submitted = true;

    if (this.form.invalid) {
      return;
    }

    this.repository.name = this.form.get("name").value;
    this.repository.description = this.form.get("description").value;
    this.repository.projects = this.selectedProjects.map((s) => s.id);
    this.repository.is_author = this.isAuthor;

    this.submitted = false;

    if (this.repository.id) {
      this.repositoriesService
        .update(this.repository.id, this.repository)
        .subscribe((repository: Repository) => {
          this.successHandler(repository);
        });
    } else {
      this.repositoriesService
        .store(this.repository)
        .subscribe((repository: Repository) => {
          this.successHandler(repository);
        });
    }
  }

  private successHandler(repository: Repository) {
    this.toast.success(Message.SUCCESS);
    this.events.broadcast("editRepositorySuccess");
    this.activeModal.close(repository);
  }

  hasProjects() {
    return this.projects.length > 0;
  }
}
